import { isApp } from '@/utils/browser.js'
const {
  webkit: {
    messageHandlers: {
      firebase,
      appsJsHandler: appsJsHandlerWebkit,
      blibliDevicePermission
    } = {}
  } = {},
  AnalyticsWebInterface: analyticWeb,
  AppsJsHandler: appsJsHandler
} = window

const hasAppApi = !!(
  analyticWeb ||
  firebase ||
  appsJsHandler ||
  appsJsHandlerWebkit
)

export default {
  getStatus () {
    return {
      isApp: isApp(),
      analyticWeb,
      firebase,
      appsJsHandler,
      appsJsHandlerWebkit,
      hasAppApi,
      blibliDevicePermission
    }
  }
}
